import React from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  ViewStyle,
} from 'react-native';
import { useTheme } from '../context/themeContext';

interface CheckboxProps {
  label?: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  style?: ViewStyle;
}

export default function Checkbox({
  label,
  checked = false,
  onChange,
  disabled = false,
  style,
}: CheckboxProps) {
  const { theme } = useTheme();
  const { colors, fontSize, fontWeight, radii } = theme;

  // Single RN code path (renders on web via react-native-web and on native).
  const boxSize = 16;

  const boxStyle: ViewStyle = {
    width: boxSize,
    height: boxSize,
    borderRadius: radii.r1,
    borderWidth: 1.5,
    borderColor: checked ? colors.accent : colors.lineStrong,
    backgroundColor: checked ? colors.accent : colors.card,
    alignItems: 'center',
    justifyContent: 'center',
  };

  return (
    <TouchableOpacity
      onPress={disabled ? undefined : () => onChange?.(!checked)}
      disabled={disabled}
      activeOpacity={0.7}
      style={[
        styles.container,
        { opacity: disabled ? 0.55 : 1 },
        style,
      ]}
      accessibilityRole="checkbox"
      accessibilityState={{ checked, disabled }}
    >
      <View style={boxStyle}>
        {checked && (
          <View style={{
            width: 8,
            height: 5,
            borderLeftWidth: 1.5,
            borderBottomWidth: 1.5,
            borderColor: colors.white,
            transform: [{ rotate: '-45deg' }, { translateY: -1 }],
          }} />
        )}
      </View>
      {label && (
        <Text style={{
          fontSize: fontSize.md,
          color: colors.ink2,
          fontFamily: theme.font.sans,
          fontWeight: fontWeight.regular,
          marginLeft: 8,
        }}>
          {label}
        </Text>
      )}
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
});
